var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "vi-button",
    class: {
      'isSmall': _vm.isSmall,
      'isOutlined': _vm.isOutlined
    },
    attrs: {
      "type": _vm.type,
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function ($ev) {
        return _vm.$emit('click', $ev);
      }
    }
  }, [_c('span', {
    staticClass: "button-label",
    class: {
      'hide-button-label': _vm.isLoading
    }
  }, [_vm._v(_vm._s(_vm.buttonLabel))]), _vm.isLoading ? _c('span', {
    staticClass: "button-loading-animation"
  }) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }